import React, { FC } from "react";
import { faStar } from "@fortawesome/free-solid-svg-icons/faStar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Star: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faStar} {...props} />
);
